"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.path = exports.requestSchema = void 0;
const zod_1 = require("zod");
const MAX_RANGE = 28 * 24 * 60 * 60 * 1000;
exports.requestSchema = zod_1.z
    .object({
    irrigationZoneIds: zod_1.z.array(zod_1.z.number()),
    dateFrom: zod_1.z.string(),
    dateTo: zod_1.z.string(),
})
    .refine((args) => {
    const dateFromStamp = Date.parse(args.dateFrom);
    const dateToStamp = Date.parse(args.dateTo);
    const areValidDates = !isNaN(dateFromStamp) && !isNaN(dateToStamp);
    const dateRange = dateToStamp - dateFromStamp;
    return areValidDates && 0 < dateRange && dateRange <= MAX_RANGE;
}, { message: 'Date range is invalid' });
exports.path = '/irrigation-scheduler-events-get';
//# sourceMappingURL=index.js.map